<template>
<div style="display: flex; flex-direction: column">

    <select v-model="cardType" @change="Search">
      <option value="tipo">TIPO</option>
      <option value="aliado">Aliados</option>
      <option value="talisman">Talismanes</option>
      <option value="arma">Armas</option>
      <option value="totem">Tótems</option>
      <option value="oro">Oros</option>
    </select>

    <input v-if="cardType != 'oro'" v-model="cardCost" @keypress="Enter" placeholder="COSTE">

    <input v-if="cardType == 'aliado'" v-model="cardAttack" @keypress="Enter" placeholder="FUERZA">
    <select v-if="cardType == 'aliado'" v-model="cardRace" @change="Search">
      <option value="raza">RAZA</option>
      <option value="caballero">Caballero</option>
      <option value="dragon">Dragón</option>
      <option value="faerie">Faeri</option>
      <option value="heroe">Héroe</option>
      <option value="olimpico">Olímpico</option>
      <option value="titan">Titán</option>
      <option value="defensor">Defensor</option>
      <option value="desafiante">Desafiante</option>
      <option value="sombra">Sombra</option>
      <option value="eterno">Eterno</option>
      <option value="faraon">Faraón</option>
      <option value="sacerdote">Sacerdote</option>
    </select>

    <select v-model="cardRarity" @change="Search">
      <option value="frecuencia">FRECUENCIA</option>
      <option value="Sin Frecuencia">Sin Frecuencia</option>
      <option value="Vasallo">Vasallo</option>
      <option value="Cortesano">Cortesano</option>
      <option value="Real">Real</option>
    </select>

    <select v-model="cardEdition" @change="Search">
      <option value="edicion">EDICIÓN</option>
      <option value="espada sagrada">Espada Sagrada</option>
      <option value="cruzadas">Cruzadas</option>
      <option value="helenica">Helénica</option>
      <option value="imperio">Imperio</option>
      <option value="hijos de daana">Hijos de Daana</option>
      <option value="tierras altas">Tierras Altas</option>
      <option value="dominios de ra">Dominios de Ra</option>
      <option value="encrucijada">Encrucijada</option>
      <option value="promo">Promo</option>
    </select>

    <input v-model="search" type="text" @keypress="Enter" placeholder="BUSQUEDA" v-if="canTextSearch">

    <div class="found-cards" style="font-size: 10px; text-align: center; color: #AAA; display: block; margin: 3px 0px">{{filteredCards.length}} CARTAS ENCONTRADAS</div>
  
</div>
</template>

<script>
export default {
    props: {
        value: {
            type: Array,
            default: () => []
        },
        cards: {
            type: Array,
            default: () => []
        },
        canTextSearch: {
            type: Boolean,
            default: true
        },
        autosearch: {
            type: Boolean,
            default: true
        },
        rule: {type: String, default: ''},
    },
    data() {
        return {
            search: '',
            filteredCards: [],
            cardType: 'tipo',
            cardCost: '',
            cardEdition: 'edicion',
            cardAttack: '',
            cardRace: 'raza',
            cardRarity: 'frecuencia',
        }
    },
    mounted() {

        this.LoadRules(this.rule);

        if(this.autosearch)
            this.Search();
    },
    methods: {
        LoadRules(ruleset) {
            let defaultRules = {S: '',T: 'tipo',C: '',E: 'edicion',A: '',R: 'raza',F: 'frecuencia'};

            if(typeof ruleset == 'string')
            {
                let arrRules = ruleset.split(/,/g);
                arrRules.forEach(rule => {
                    let parts = rule.split(':');
                    if(parts.length >= 2)
                    {
                        let ruleKey = parts[0];
                        let ruleValue = parts[1];
                        defaultRules[ruleKey] = ruleValue;
                    }
                });
            }

            this.search = defaultRules.S;
            this.cardType = defaultRules.T;
            this.cardCost = defaultRules.C;
            this.cardEdition = defaultRules.E;
            this.cardAttack = defaultRules.A;
            this.cardRace = defaultRules.R;
            this.cardRarity = defaultRules.F;
        },
        Enter(e) {
            if(e.code == 'Enter' && this.autosearch)
                this.Search();
        },
        NumericCondition(value, target)
        {
            var op = '=';
            if(value.indexOf('>=') > -1 ) op = '>=';
            else if(value.indexOf('<=') > -1) op = '<=';
            else if(value.indexOf('+') > -1) op = '>=';
            else if(value.indexOf('-') > -1) op = '<=';
            else if(value.indexOf('>') > -1) op = '>';
            else if(value.indexOf('<') > -1) op = '<';
            else if(value.indexOf('!') > -1) op = '!=';
            else if(value.indexOf(',') > -1)
            {
                var range = value.split(/,/g);
                if(range.length >= 2)
                {
                    var min = parseInt(range[0]);
                    var max = parseInt(range[1]);
                    return target >= min && target <= max;
                }
                return false;
            }
            else if(value.indexOf('.') > -1)
            {
                var range = value.split(/\./g);
                if(range.length >= 2)
                {
                    var min = parseInt(range[0]);
                    var max = parseInt(range[1]);
                    return target <= min || target >= max;
                }
                return false;
            }

            value = parseInt(value.replace(/[^0-9]+/g, ''));
            if(isNaN(value)) return true;
            switch(op)
            {
                case '=': return target == value;
                case '>=': return target >= value;
                case '<=': return target <= value;
                case '>': return target > value;
                case '<': return target < value;
                case '!': return target != value;
            }
            return false;
        },
        FilterCard(card)
        {
            //chequear por edicion
            var checkEdition = (this.cardEdition == 'edicion' || this.cardEdition == card.expansion.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '')) ;

            //chequear por tipo de carta
            var checkType = (this.cardType == 'tipo' || this.cardType == card.tipo.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '')) ;
            
            //Checkear coste
            var checkCost = (card.tipo == 'Oro' && this.cardCost.trim() == '') || (card.tipo != 'Oro' && this.NumericCondition(this.cardCost, card.coste));

            //chequear por fuerza aliado
            var checkAttack = card.tipo != 'Aliado' || (card.tipo == 'Aliado' && this.NumericCondition(this.cardAttack, card.fuerza));

            //chequear por raza aliado
            var checkRace = this.cardType != 'raza' || this.cardRace == 'aliados' || (this.cardType == 'aliado' && card.raza.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '') == this.cardRace);

            //chequear por frequencia
            var checkRarity = this.cardRarity == 'frecuencia' || card.frecuencia == this.cardRarity;

            return checkEdition && checkType && checkCost && checkAttack && checkRace && checkRarity;    
        },
        Search() {
            var ret = [];
            var search = this.search.toUpperCase().split('+');
            for(var i = 0; i < this.cards.length; i++)
            {
                var card = this.cards[i];
                var content = (card.nombre + ' ' + card.habilidad).toUpperCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '');

                if(this.FilterCard(card))
                {
                var addCard = true;
                if(!this.search.trim() == '')
                {
                    for(var j = 0; j < search.length; j++)
                    {
                    if(content.indexOf(search[j].trim()) == -1)
                    {
                        addCard = false;
                        break;
                    }
                    }
                }
                if(addCard)
                    ret.push(card);
                }
                
            }
            this.filteredCards = ret;
            console.log(this.filteredCards.length);
            this.$emit('input', this.filteredCards);
        },
    },
    computed: {
        currentRule() {
            return {S: this.search,T: this.cardType,C: this.cardCost,E: this.cardEdition,A: this.cardAttack,R: this.cardRace,F: this.cardRarity};
        }
    },
    watch: {
        currentRule(n, o) {
            //console.log('rule changed');
            let rule = `S:${n.S},T:${n.T},C:${n.C},E:${n.E},A:${n.A},R:${n.R},F:${n.F}`;
            this.$emit('FilterChanged', rule);
        },
        rule(n, o) {
            //console.log('load rules');
            this.LoadRules(n);
        }
    }
}
</script>

<style>
select {
    height: 35px;
}
.row-filter {
    flex-direction: row !important;
    gap: 4px;
}
.row-filter > * {
    height: 100%;
}
.row-filter .found-cards {
    display: none !important;
}
.row-filter input {
    width: 100px;
}
.row-filter.sm input, .row-filter.sm select {
    font-size: 12px !important;
    max-width: 70px;
}
</style>